<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive :max="11">
      <component :is="Component" :key="resolveCacheKey(route)" />
    </keep-alive>
  </router-view>
</template>

<script>
// Matches paths whose final (or pre-query) segment is "create" or "new" —
// e.g. /erp/purchase-orders/create, /erp/service-invoices/new,
// /erp/vouchers/create?type=Sales. Does NOT match /apps/nft-create,
// /auth/create-pwd-basic, /apps/projects-create, etc.
const CREATE_ROUTE_RE = /\/(create|new)(?:[/?]|$)/;

export default {
  name: "App",
  data() {
    // Bumped before every navigation that lands on a /create or /new route.
    // Used to derive a unique :key for that route so <keep-alive> mounts a
    // fresh component instance instead of returning a stale cached one
    // pre-filled with data from the previously created entity.
    return { createNavStamp: 0 };
  },
  created() {
    if (this.$router && !this.$router.__createKeyHookInstalled) {
      this.$router.__createKeyHookInstalled = true;
      this.$router.beforeEach((to) => {
        if (CREATE_ROUTE_RE.test(to.path)) this.createNavStamp++;
        return true;
      });
    }
  },
  mounted() {
    if (localStorage.getItem("jwt")) {
      this.$store.dispatch("company/hydrate").catch(() => {});
      this.$store.dispatch("printProfile/hydrate").catch(() => {});

      // Best-effort Web Push registration. No-ops if the user has not
      // granted notification permission or VAPID is unconfigured server-side.
      import("@/helpers/notificationsService").then(({ getNotificationsService }) => {
        try { getNotificationsService().ensureWebPushSubscribed(); } catch { /* ignore */ }
      });
    }
  },
  methods: {
    resolveCacheKey(route) {
      if (CREATE_ROUTE_RE.test(route.path)) {
        return `${route.fullPath}::${this.createNavStamp}`;
      }
      return route.fullPath;
    },
  },
};
</script>
